var map = {
	"./Footer": 834,
	"./Footer.js": 834,
	"./Header": 8140,
	"./Header.js": 8140,
	"./Layout": 2111,
	"./Layout.js": 2111,
	"./Top": 2242,
	"./Top.js": 2242,
	"./app-error": 7761,
	"./app-error.js": 7761,
	"./banner": 5555,
	"./banner.js": 5555,
	"./blogcards": 5494,
	"./blogcards.js": 5494,
	"./blogs": 5300,
	"./blogs.js": 5300,
	"./business": 2931,
	"./business.js": 2931,
	"./cards": 9142,
	"./cards.js": 9142,
	"./cards2": 6366,
	"./cards2.js": 6366,
	"./cards3": 2893,
	"./cards3.js": 2893,
	"./cards4": 5688,
	"./cards4.js": 5688,
	"./cards5": 47,
	"./cards5.js": 47,
	"./cards6": 4146,
	"./cards6.js": 4146,
	"./corporate": 4070,
	"./corporate.js": 4070,
	"./diversitycards": 2379,
	"./diversitycards.js": 2379,
	"./events": 1040,
	"./events.js": 1040,
	"./form1": 3592,
	"./form1.js": 3592,
	"./h1": 1994,
	"./h1.js": 1994,
	"./icons": 7783,
	"./icons.js": 7783,
	"./not-found-layout": 8704,
	"./not-found-layout.js": 8704,
	"./p": 9354,
	"./p.js": 9354,
	"./partners": 9690,
	"./partners.js": 9690,
	"./ready": 2462,
	"./ready.js": 2462,
	"./services": 3253,
	"./services.js": 3253,
	"./slider1": 7769,
	"./slider1.js": 7769,
	"./slider2": 4816,
	"./slider2.js": 4816,
	"./slider3": 8967,
	"./slider3.js": 8967,
	"./speak": 8111,
	"./speak.js": 8111,
	"./tabs": 8349,
	"./tabs.js": 8349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9261;